// extracted by mini-css-extract-plugin
module.exports = {"cards-list":"styles_cards-list__8gXIo","no-carousel":"styles_no-carousel__6FAcR","type-3":"styles_type-3__yII8o","type-2":"styles_type-2__sBA21"};